import React, { useRef, createContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Sidebar from '../../components/SideBar/SideBar';
import AdminHeader from '../../components/Header/AdminHeader';
import { GetInfoEventRequested, ClearGetInfoEvent } from '../../actions/EventManagement';

import styles from '../../assets/jss/pages/adminLayoutStyle';

const useStyles = makeStyles(styles);

export const MainContext = createContext();

const AdminLayout = (props) => {
    const {
        routes,
        children,
        fetchInfo,
        clearInfo,
        ...rest
    } = props;
    const classes = useStyles();
    const mainPanelRef = useRef(null);
    const { shortName } = useParams();

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    useEffect(() => {
        if (shortName) fetchInfo(shortName);
        return clearInfo;
    }, [shortName, fetchInfo, clearInfo]);

    return (
        <div className={classes.wrapper}>
            <Sidebar
                routes={routes}
                {...rest}
            />
            <div className={classes.mainPanel} ref={mainPanelRef}>
                <AdminHeader routes={routes} />
                <div className={classes.content}>
                    <MainContext.Provider value={mainPanelRef}>
                        {children}
                    </MainContext.Provider>
                </div>
            </div>
        </div>
    );
};

AdminLayout.defaultProps = {
    routes: {},
    children: undefined,
};

AdminLayout.propTypes = {
    routes: PropTypes.oneOfType([() => null, PropTypes.object]),
    children: PropTypes.oneOfType([() => null, PropTypes.element, PropTypes.object, PropTypes.array]),
    fetchInfo: PropTypes.func.isRequired,
    clearInfo: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    eventInfo: state.eventManagement.infoEvent.data,
});

const mapDispatchToProps = (dispatch) => ({
    fetchInfo: (event) => {
        dispatch(GetInfoEventRequested(event));
    },
    clearInfo: () => {
        dispatch(ClearGetInfoEvent());
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminLayout);
